import { EnableSidebar, PageTitle } from '../../../_metronic/layout/core'
import { useEffect, useState } from 'react'
import { Vertical } from '../../modules/wizards/components/Vertical';
import { getAnnouncements } from '../announcement/list/core/_requests'
import { useLang } from '../../../_metronic/i18n/Metronici18n'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl';
import { useAuth } from '../../modules/auth';
import { AdminInfoBox } from './AdminInfoBox';

const DashboardPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const lang = useLang()
  const intl = useIntl();
  const { currentUser } = useAuth();

  useEffect(() => {
    getAnnouncements().then((a: any) => {
      const activeAnnouncements = a.data?.data?.filter((k: any) => k.isActiveDashboard) || [];
      setAnnouncements(activeAnnouncements);
     
    });
  }, [])



  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'Dashboard' })}</PageTitle>

      {currentUser?.roleName === "ADMIN" ? <AdminInfoBox /> : <div className='d-flex w-100 gap-5 pb-5'>
        <Link className="btn btn-success" to="/preference">{intl.formatMessage({ id: 'MENU.PREFERENCE' })}</Link>
        <Link className="btn btn-primary" to="/myplacement">{intl.formatMessage({ id: 'MENU.MYPLACEMENT' })}</Link>
      </div>}


      {announcements.map((a: any) => {
        return (lang === "tr" ? <div className="alert alert-primary mt-5">{a.text}</div>
          : <div className="alert alert-primary mt-5">{a.textEn}</div>
        )
      })}
    </>
  )
}

const DashboardWrapper = () => {
  return (
    <EnableSidebar>
      <PageTitle breadcrumbs={[]}>Dashboard</PageTitle>
      <div className='card-xl-stretch mb-5 mb-xl-10'>
        <Vertical />
      </div>

    </EnableSidebar>
  )
}

export { DashboardPage }
